import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import '../css/subscription.css';

const SubscriptionSuccess = () => {
    const history = useHistory();
    // const location = useLocation(); // Unused
    const [countdown, setCountdown] = useState(5);

    // Get session_id from URL if needed for verification
    // const searchParams = new URLSearchParams(location.search);
    // const sessionId = searchParams.get('session_id'); // Unused for now

    useEffect(() => {
        // Countdown and redirect
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    history.push('/dashboard');
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [history]);

    return (
        <div className="subs container" style={{ textAlign: 'center', paddingTop: '50px' }}>
            <div style={{ fontSize: '60px', marginBottom: '20px' }}><span role="img" aria-label="party popper">🎉</span></div>
            <h1 style={{ color: '#4CAF50', marginBottom: '20px' }}>Abonnement activé !</h1>
            <p style={{ fontSize: '18px', marginBottom: '30px' }}>
                Merci pour votre confiance ! Votre abonnement Explique-Moi Pythagore est maintenant actif.
            </p>
            <p style={{ color: '#666' }}>
                Vous pouvez désormais commander des cours illimités.
            </p>
            <p style={{ marginTop: '30px', color: '#999' }}>
                Redirection vers le tableau de bord dans {countdown} secondes...
            </p>
            <button
                className="btn blue rounded"
                onClick={() => history.push('/dashboard')}
                style={{ marginTop: '20px' }}
            >
                Aller au tableau de bord
            </button>
        </div>
    );
};

export default SubscriptionSuccess;
